module.exports = __webpack_public_path__ + "static/media/develop-05.bdc44219.png";